import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Modal,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getReport } from "../../../redux/actions/reportAction";
import { getAllCategorys } from "../../../redux/actions/categories";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class SalesOverview extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'SALESOVERVIEW_REPORT',
      path: ["Home", "Sales Overview Report"],
      links: ["home", "report/sales-overview"],
      date: new Date(),
      startDate: new Date(),
      range: false,
      disabled: false,
      isLoading: "false",
      csvData: "",
      reportData: "",
      historyPopup: false, 
      payoutHistory: '',
      offerIDs: '',
      merchantIDs: '',
      paymentTermID: '',
      payoutList: '',
      catData: '',
      catID: '',
      merchantTypeID: '',
      dealType: '',
      totalRecords: 0,
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = date => this.setState({ startDate: date });
  onChangeStartDateRange = date => this.setState({ startDateRange: date });
  changeDatePicker = status => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    if(e.target.name == 'dealType'){
      this.props.getAllCategorys({categoryType: e.target.value, page:0});
      this.setState({catID: ''});
    }
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;

    if (!err) {
      isLoading = "true";
      if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData = {
          startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
          endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
          catID:  this.state.catID,
          merchantTypeID: this.state.merchantTypeID,
          offerIDs: this.state.offerIDs,
          merchantIDs: this.state.merchantIDs,
          dealType: this.state.dealType,
        };
      } else {
        formData = {
          startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
          catID:  this.state.catID,
          merchantTypeID: this.state.merchantTypeID,
          offerIDs: this.state.offerIDs,
          merchantIDs: this.state.merchantIDs,
          dealType: this.state.dealType,
        };
      }

      this.props.getReport(formData, 'report/sales-overview');
    } else {
      isLoading = "false";
    }
  }

  Clear = () => {};

  handlePageChange = page => {};

  componentWillMount() {
    isLoading = "true";
    this.props.clearAlert();
    this.handleDismiss();
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData) {
      if(siteData.combine_products == 'disable') {
        this.setState({dealType: 'offer'});
        this.props.getReport({startDate: moment(this.state.startDate).format('YYYY-MM-DD'), dealType:'offer'}, 'report/sales-overview');
        this.props.getAllCategorys({categoryType: 'offer', page: 0});
      }else{
        this.props.getReport({startDate: moment(this.state.startDate).format('YYYY-MM-DD')}, 'report/sales-overview');
        this.props.getAllCategorys({categoryType: this.state.dealType, page: 0});
      }
    }    
  }
  componentWillReceiveProps(nextProps) {

    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        isLoading = "false";
        this.setState({ totalRecords: nextProps.reportData.total_record});
        this.setState({ reportData: nextProps.reportData});
        this.handleExport(nextProps.reportData);
      }
    }

    if (this.props.catData !== nextProps.catData) {
      if (nextProps.catData) {
        isLoading = "false";
        this.setState({catData: nextProps.catData.data});
      }
    }

    if (nextProps.message) {
      isLoading = "false";
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }


  }

  handleExport = data => {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }
    let setDate = (this.state.range == true && this.state.startDateRange) ? moment(dateRange[0]).format('MM/DD/YYYY') +' - '+moment(dateRange[1]).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY');
    csvData = [
      [
        'Data up to the date: ' + setDate,
      ], 
      [
        'Type',
        'Merchant Name',
        'Offer ID',
        'Offer Name',
        'Offer Price',
        'Remittance',
        'Pause?',
        'Market',
        'Sales Rep',
        'Offer Start Date',
        'Offer End Date',
        'Voucher To be Sold',
        'Quantity',
        'Refund',
        'Revenue', 
        'Gross Billing',
      ]
    ];

    {data &&
      data.data.map((payData, payIndex) => 
        csvData.push([
          (payData.proposal_type == '10') ? 'Product' : (payData.proposal_type == '11') ? 'Auction' : 'Offer',
          payData.merchantName,
          payData.dealID,
          payData.dealText,
          payData.offerPrice,
          payData.remittance,
          payData.paused,
          payData.title, 
          payData.salesrep,
          payData.executionDateTime, 
          payData.expiryDateTime, 
          payData.quantityToSold, 
          payData.quantity, 
          payData.refund,
          payData.revenue,
          payData.grossBilling,
        ])
      )
    }

    {data &&
      data.total && 
      csvData.push([
        'Total',
        '',
        '',
        '',
        '',
        '', 
        '',
        '', 
        '',
        '',
        '',
        data.total.quantityToSold , 
        data.total.quantity, 
        data.total.refund,
        data.total.revenue,
        data.total.grossBilling,
      ])
    }

    this.setState({ csvData: csvData });
  };

  render() {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Sales Overview Report</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {this.state.range == false ? (
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    ) : (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                    )}
                  </FormGroup>
                </Col> 
                <Col md={3} xs={12}>
                  <FormGroup controlId="formParentID">
                    <ControlLabel>Deal Type</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="dealType"
                      onChange={this.handleChange}
                      placeholder="select"
                      value={this.state.dealType}
                      >
                      <option value="">All</option>
                      <option value="offer">Offer</option>
                      <option value="products">Products</option>
                      <option value="auction">Auction</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup>
                    <ControlLabel>Merchant IDs (separate by comma)</ControlLabel>
                    <FormControl
                      type="text"
                      name="merchantIDs"
                      value={this.state.merchantIDs}
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup>
                    <ControlLabel>Deal IDs (separate by comma)</ControlLabel>
                    <FormControl
                      type="text"
                      name="offerIDs"
                      value={this.state.offerIDs}
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="catID">
                    <ControlLabel>Category</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.catIDError }}
                      name="catID"
                      onChange={this.handleChange}
                      value={this.state.catID}
                    >
                      <option value="">All</option>
                      {!isEmpty(this.state.catData) &&
                        this.state.catData.map((type, index) => (
                          <option key={type.catID} value={type.catID}>
                            {type.catName}
                          </option>
                        ))}
                    </FormControl>
                  </FormGroup>
                </Col>  
                <Col md={3} xs={12}>
                  <FormGroup controlId="formParentID">
                    <ControlLabel>Proposal Type</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="merchantTypeID"
                      onChange={this.handleChange}
                      placeholder="select"
                      value={this.state.merchantTypeID}
                    >
                      <option value="">All</option>
                      <option value="1">Standard Merchant</option>
                      <option value="2">Premium Merchant</option>
                      <option value="3">Products</option>
                      <option value="4">Travel</option>
                      <option value="5">Events</option>
                      <option value="6">Coupon Offer</option>
                      <option value="7">Affiliate Offer</option> 
                      <option value="8">Gift Card Vouchers</option>
                      <option value="9">Recurring Billing</option> 
                      <option value="10">Product Deal</option>
                      <option value="11">Auction</option>
                    </FormControl>
                  </FormGroup>
                </Col>          
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  {this.state.csvData ? (
                    <CSVLink
                      data={this.state.csvData}
                      filename={"salesoverview-report.csv"}
                      className="btn btn-default"
                    >
                      Export CSV
                    </CSVLink>
                  ) : null}
                  {this.state.range == false ? (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Range
                    </a>
                  ) : (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Date
                    </a>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body table-responsive">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th colSpan="13">Data up to the date: {(this.state.range == true && this.state.startDateRange) ? moment(dateRange[0]).format('MM/DD/YYYY') +' - '+moment(dateRange[1]).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY')}</th>
                </tr>
                <tr>
                  <th colSpan="13">Total Records : {this.state.totalRecords}</th>
                </tr>
                <tr>
                  <th>Type</th>
                  <th>Merchant Name</th>
                  <th>Offer ID</th>
                  <th>Offer Name</th>
                  <th>Offer Price</th>
                  <th>Remittance</th>
                  <th>Pause?</th>
                  <th>Market</th> 
                  <th>Sales Rep</th>
                  <th>Offer Start Date</th> 
                  <th>Offer End Date</th>
                  <th>Voucher To be Sold</th> 
                  <th>Quantity</th> 
                  <th>Refund</th> 
                  <th>Revenue</th> 
                  <th>Gross Billing</th> 
                </tr>
              </thead>
              <tbody>
              {this.state.reportData ?
                  this.state.reportData.data.map((payData, payIndex) =>
                    <tr key={payData.offerID + payIndex}>
                      <td>{(payData.proposal_type == '10') ? 'Product' : (payData.proposal_type == '11') ? 'Auction' : 'Offer'}</td>
                      <td>{payData.merchantName}</td>
                      <td>{payData.dealID}</td>
                      <td>{payData.dealText}</td>
                      <td>{payData.offerPrice}</td>
                      <td>{payData.remittance}</td>
                      <td>{payData.paused}</td> 
                      <td>{payData.title}</td>
                      <td>{payData.salesrep}</td>
                      <td>{payData.executionDateTime}</td> 
                      <td>{payData.expiryDateTime}</td>
                      <td>{payData.quantityToSold}</td> 
                      <td>{payData.quantity }</td> 
                      <td>{payData.refund}</td> 
                      <td>{payData.revenue}</td> 
                      <td>{payData.grossBilling }</td> 
                    </tr> 
                  )
                :
                <tr><td colSpan="14">Data Not Found</td></tr>
              }
              {this.state.reportData.total && 
                <tr key={Math.random()}>
                  <td colSpan="10">Total</td> 
                  <td>{this.state.reportData.total.quantityToSold}</td> 
                  <td>{this.state.reportData.total.quantity }</td> 
                  <td>{this.state.reportData.total.refund}</td> 
                  <td>{this.state.reportData.total.revenue}</td> 
                  <td>{this.state.reportData.total.grossBilling }</td> 
                </tr>
              }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    reportData: state.reportReducer.reportData,
    catData: state.categoryReducer.catData,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getReport,
    getAllCategorys,
  })
)(SalesOverview);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/SalesOverview.js